export const CLEAR_REDUCER = 'CLEAR_REDUCER'

export interface ClearActionType {
  type: typeof CLEAR_REDUCER
}
